    (function(){
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

      // WhatsApp deep-links
      var msg = "Olá! Acessei o site da ZÁVIA e gostaria de solicitar um diagnóstico inicial de riscos e proteção. Minha empresa atua no segmento de ________.";
      var wa = "https://wa.me/5511934248161?text=" + encodeURIComponent(msg);
      Array.prototype.forEach.call(document.querySelectorAll('.js-wa'), function(a){ a.href = wa; a.target = "_blank"; a.rel = "noopener"; });

      // Nav background on scroll
      var nav = document.getElementById('nav');
      var onScroll = function(){ nav.classList.toggle('scrolled', window.scrollY > 40); };
      onScroll();

      // Lenis smooth scroll
      var lenis = null;
      if(!reduce && window.Lenis){
        lenis = new Lenis({ lerp:0.1, wheelMultiplier:1, smoothWheel:true });
        lenis.on('scroll', onScroll);
        function raf(t){ lenis.raf(t); requestAnimationFrame(raf); }
        requestAnimationFrame(raf);
        // anchor links through Lenis
        Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), function(a){
          a.addEventListener('click', function(e){
            var id = a.getAttribute('href');
            if(id.length>1){ var el=document.querySelector(id); if(el){ e.preventDefault(); lenis.scrollTo(el,{offset:-10}); } }
          });
        });
      }
      window.addEventListener('scroll', onScroll, {passive:true});

      // Reveal on scroll (staggered)
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){
            var kids = en.target.querySelectorAll('.up');
            Array.prototype.forEach.call(kids, function(k,i){ k.style.transitionDelay = Math.min(i*70,460)+'ms'; });
            en.target.classList.add('in');
            io.unobserve(en.target);
          }
        });
      }, { threshold:0.12, rootMargin:'0px 0px -7% 0px' });
      var sections = document.querySelectorAll('#hero, .section');
      Array.prototype.forEach.call(sections, function(s){ io.observe(s); });

      // safety net: reveal anything already in view on load (independent of IO firing)
      requestAnimationFrame(function(){
        Array.prototype.forEach.call(sections, function(s){
          var r = s.getBoundingClientRect();
          if(r.top < innerHeight*0.92 && r.bottom > 0){
            var kids = s.querySelectorAll('.up');
            Array.prototype.forEach.call(kids, function(k,i){ k.style.transitionDelay = Math.min(i*70,460)+'ms'; });
            s.classList.add('in'); io.unobserve(s);
          }
        });
      });
    })();
